(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6658],{

/***/ 81977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ trust_center; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/DividerSection/DividerSection.tsx + 1 modules
var DividerSection = __webpack_require__(52876);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Subnav/index.ts + 20 modules
var Subnav = __webpack_require__(49833);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Subnavigation/data.ts
var data = [{
  label: "Security",
  id: "security",
  href: "security"
}, {
  label: "Data Privacy",
  id: "data-privacy",
  href: "data-privacy"
}, {
  label: "Compliance",
  id: "compliance",
  href: "compliance"
}, {
  label: "Regional Segment",
  id: "regional-segment",
  href: "regional-segment"
}, {
  label: "Infrastructure",
  id: "infrastructure",
  href: "infrastructure"
}];
/* harmony default export */ var Subnavigation_data = (data);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Subnavigation/Subnavigation.tsx




var TITLE = "Trust Center";

var Subnavigation = function Subnavigation() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* default */.Z, {
    "aria-label": TITLE,
    label: TITLE,
    children: Subnavigation_data.map(function (item) {
      var scroll = (0,useScrollToAnchor/* default */.Z)(item.id, -100);
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
        label: item.label,
        href: item.href,
        onClick: function onClick(e) {
          e.preventDefault();
          scroll();
        }
      }, item.label);
    })
  });
};

/* harmony default export */ var Subnavigation_Subnavigation = (Subnavigation);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Hero/Hero.tsx










var Description = function Description() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: ["Twilio\u2019s CDP is #1 for 2022 market share per ", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      href: "https://segment.com/learn/download/idc-marketshare-2022/",
      children: "IDC"
    }), ", built for companies trying to grow in a privacy-conscious world. With built-in security, privacy, and resilience, it enables personalized experiences, regulatory compliance, and customer trust. Backed by industry-standard frameworks and ", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      href: (0,getAbsoluteUrl/* default */.Z)("/docs/guides/regional-segment/", pageConfig),
      children: "regional infrastructure"
    }), " ", " in Europe and the United States, Segment helps companies succeed with a privacy-first approach."]
  });
};

var copy = {
  heading: "Segment Trust Center",
  description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {})
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroRecipeBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: copy.description
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Hero_Hero = (Hero);

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "ek2mpoq1"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:0;", function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up("sm"), "{padding-bottom:40px;}", theme.breakpoints.up("xl"), "{padding-bottom:80px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";}" + ( true ? "" : 0));

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "ek2mpoq0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/GettingStarted/GettingStarted.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var GettingStarted_copy = {
  heading: "Getting started is easy",
  description: "Start connecting your data with Segment",
  buttonTitle: "Get a demo"
};

var GettingStarted = function GettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: GettingStarted_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: GettingStarted_copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          children: GettingStarted_copy.buttonTitle
        })
      })]
    })
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ez4uj5z2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:40px;padding-bottom:40px;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:80px;padding-bottom:80px;}" + ( true ? "" : 0));

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ez4uj5z1"
} : 0)("display:grid;justify-content:center;row-gap:32px;padding:0 20px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:40px;}" + ( true ? "" : 0));

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ez4uj5z0"
} : 0)( true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0);

/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/BuildCustomerTrust/BuildCustomerTrust.tsx


function BuildCustomerTrust_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var BuildCustomerTrust = function BuildCustomerTrust() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var copy = (0,react.useMemo)(function () {
    return {
      title: "Build customer trust and take a proactive approach to privacy",
      columns: [{
        title: "Privacy Portal",
        content: "With the Segment Privacy Portal, you can automate your approach to keeping your customers' data private. Gain real-time visibility into the personal information you collect, its sources, and destinations. Set rules to automatically protect it.",
        buttonTitle: "Explore Privacy Portal",
        buttonHref: (0,getAbsoluteUrl/* default */.Z)("/product/privacy-portal/", pageConfig),
        target: "_self"
      }, {
        title: "Certifications and attestations",
        content: "Segment\u2019s security and privacy program is based on and aligned with industry-standard frameworks, and we maintain a comprehensive suite of certifications and attestations to further demonstrate our commitment to security and privacy.",
        buttonTitle: "View certificates",
        buttonHref: "https://assets.ctfassets.net/9u2t3ap6pctb/6nPHU2NWIvn2TkBo0CulHa/329a41b7cbd7edfbe9a42cd9973040d7/Segment_ISO_27001_Certificate.pdf",
        target: "_blank"
      }]
    };
  }, [pageConfig]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: copy.title
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        overrides: {
          md: 2
        },
        children: copy.columns.map(function (column, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              tag: "h3",
              variant: "h4",
              children: column.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              tag: "p",
              variant: "pMedium",
              children: column.content
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
              href: column.buttonHref,
              target: column.target,
              children: column.buttonTitle
            })]
          }, index);
        })
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1iaa5a21"
} : 0)( true ? {
  name: "3hppma",
  styles: "max-width:1120px"
} : 0);

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1iaa5a20"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{gap:80px;}" + ( true ? "" : 0));

/* harmony default export */ var BuildCustomerTrust_BuildCustomerTrust = (BuildCustomerTrust);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/CuriousAbout/CuriousAbout.tsx




var CuriousAbout_copy = {
  title: "Curious about Twilio's entire Customer Engagement Platform?",
  buttonTitle: "Visit Twilio Trust Center",
  buttonHref: "https://www.twilio.com/en-us/trust-center/"
};

var CuriousAbout = function CuriousAbout() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h4",
          children: CuriousAbout_copy.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: CuriousAbout_copy.buttonHref,
          children: CuriousAbout_copy.buttonTitle
        })]
      })
    })
  });
};

/* harmony default export */ var CuriousAbout_CuriousAbout = (CuriousAbout);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/CustomerEngagement/CustomerEngagement.tsx






var HEADING = "Customer engagement built on trust";

var CustomerEngagement = function CustomerEngagement() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerEngagement_StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CompliantIcon */.Kg, {
        size: "large"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "h2",
        children: HEADING
      })]
    })
  });
};

/* harmony default export */ var CustomerEngagement_CustomerEngagement = (CustomerEngagement);

var CustomerEngagement_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ep6qupr0"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Security/assets/Security-md.png
var Security_md = __webpack_require__(7519);
var Security_md_default = /*#__PURE__*/__webpack_require__.n(Security_md);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Security/assets/Security-md@2x.png
var Security_md_2x = __webpack_require__(75736);
var Security_md_2x_default = /*#__PURE__*/__webpack_require__.n(Security_md_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Security/assets/Security-md.webp
var assets_Security_md = __webpack_require__(84561);
var assets_Security_md_default = /*#__PURE__*/__webpack_require__.n(assets_Security_md);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Security/assets/Security-md@2x.webp
var assets_Security_md_2x = __webpack_require__(11037);
var assets_Security_md_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Security_md_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Security/assets/Security-xs@2x.png
var Security_xs_2x = __webpack_require__(25471);
var Security_xs_2x_default = /*#__PURE__*/__webpack_require__.n(Security_xs_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Security/assets/Security-xs.webp
var Security_xs = __webpack_require__(59193);
var Security_xs_default = /*#__PURE__*/__webpack_require__.n(Security_xs);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Security/assets/Security-xs@2x.webp
var assets_Security_xs_2x = __webpack_require__(63940);
var assets_Security_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Security_xs_2x);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Security/SecurityImage.tsx












var SecurityImage = function SecurityImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      media: theme.breakpoints.up("md", false),
      srcSet: "".concat((assets_Security_md_default()), ", ").concat((assets_Security_md_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("md", false),
      srcSet: "".concat((Security_md_default()), ", ").concat((Security_md_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Security_xs_default()), ", ").concat((assets_Security_xs_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (Security_xs_2x_default()),
      alt: "Security",
      width: "641",
      height: "402",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Security_SecurityImage = (SecurityImage);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Security/Security.tsx


function Security_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Security_copy = {
  overline: "Security",
  heading: "Safeguard your data",
  description: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: ["Security and privacy are key focus areas for our product development organization. We use data encryption, multi-factor authentication, and", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      href: "https://security.segment.com/",
      children: "maintain certifications and attestations"
    }), " to ensure that our customers' data, as well as their customers' data, is always safe and secure.`"]
  })
};
var Security_link = {
  text: "Learn about Segment Security",
  url: "/security/"
};

var Customer = function Customer() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Security_Wrapper, {
    id: "security",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Security_StyledSectionBase, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: Security_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h3",
            children: Security_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: Security_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
            size: "medium",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(Security_link.url, pageConfig),
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: Security_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Security_SecurityImage, {})
      })]
    })
  });
};

var Security_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "eyp0qn53"
} : 0)("display:grid;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:45px;}" + ( true ? "" : 0));

var Security_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eyp0qn52"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "eyp0qn51"
} : 0)( true ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : 0);

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "eyp0qn50"
} : 0)("display:flex;align-items:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:392px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var Security = (Customer);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Privacy/assets/Privacy-md.png
var Privacy_md = __webpack_require__(32377);
var Privacy_md_default = /*#__PURE__*/__webpack_require__.n(Privacy_md);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Privacy/assets/Privacy-md@2x.png
var Privacy_md_2x = __webpack_require__(46418);
var Privacy_md_2x_default = /*#__PURE__*/__webpack_require__.n(Privacy_md_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Privacy/assets/Privacy-md.webp
var assets_Privacy_md = __webpack_require__(93810);
var assets_Privacy_md_default = /*#__PURE__*/__webpack_require__.n(assets_Privacy_md);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Privacy/assets/Privacy-md@2x.webp
var assets_Privacy_md_2x = __webpack_require__(44655);
var assets_Privacy_md_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Privacy_md_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Privacy/assets/Privacy-xs@2x.png
var Privacy_xs_2x = __webpack_require__(84786);
var Privacy_xs_2x_default = /*#__PURE__*/__webpack_require__.n(Privacy_xs_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Privacy/assets/Privacy-xs.webp
var Privacy_xs = __webpack_require__(50604);
var Privacy_xs_default = /*#__PURE__*/__webpack_require__.n(Privacy_xs);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Privacy/assets/Privacy-xs@2x.webp
var assets_Privacy_xs_2x = __webpack_require__(26474);
var assets_Privacy_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Privacy_xs_2x);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Privacy/PrivacyImage.tsx












var PrivacyImage = function PrivacyImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      media: theme.breakpoints.up("md", false),
      srcSet: "".concat((assets_Privacy_md_default()), ", ").concat((assets_Privacy_md_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("md", false),
      srcSet: "".concat((Privacy_md_default()), ", ").concat((Privacy_md_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Privacy_xs_default()), ", ").concat((assets_Privacy_xs_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (Privacy_xs_2x_default()),
      alt: "Privacy",
      width: "640",
      height: "459",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Privacy_PrivacyImage = (PrivacyImage);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Privacy/Privacy.tsx


function Privacy_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Privacy_copy = {
  overline: "Privacy",
  heading: "Protect sensitive user data",
  description: "We are committed to protecting your data and the data of your users. Segment is designed to keep data secure while adhering to the most up-to-date data protection laws around the world. Importantly, all the data stored on the Segment platform is owned by you, and we will never sell it."
};
var Privacy_link = {
  text: "Learn about Segment Privacy",
  url: "/security/#commitment-to-data-privacy"
};

var Privacy_Customer = function Customer() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Privacy_Wrapper, {
    id: "data-privacy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Privacy_StyledSectionBase, {
      variant: "2Col",
      copyVariant: "narrow",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Privacy_SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: Privacy_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h3",
            children: Privacy_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: Privacy_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Privacy_LinkWrapper, {
            size: "medium",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(Privacy_link.url, pageConfig),
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: Privacy_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Privacy_PrivacyImage, {})
      })]
    })
  });
};

var Privacy_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1elcrao3"
} : 0)("display:grid;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:45px;}" + ( true ? "" : 0));

var Privacy_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1elcrao2"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:0;grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var Privacy_LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1elcrao1"
} : 0)( true ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : 0);

var Privacy_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1elcrao0"
} : 0)("display:flex;align-items:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:392px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var Privacy = (Privacy_Customer);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Compliance/assets/Compliance@2x.png
var Compliance_2x = __webpack_require__(97637);
var Compliance_2x_default = /*#__PURE__*/__webpack_require__.n(Compliance_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Compliance/assets/Compliance.webp
var Compliance = __webpack_require__(81540);
var Compliance_default = /*#__PURE__*/__webpack_require__.n(Compliance);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Compliance/assets/Compliance@2x.webp
var assets_Compliance_2x = __webpack_require__(48664);
var assets_Compliance_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Compliance_2x);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Compliance/ComplianceImage.tsx







var ComplianceImage = function ComplianceImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Compliance_default()), ", ").concat((assets_Compliance_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (Compliance_2x_default()),
      alt: "Compliance",
      width: "521",
      height: "482",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Compliance_ComplianceImage = (ComplianceImage);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Compliance/Compliance.tsx


function Compliance_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Compliance_copy = {
  overline: "Compliance",
  heading: "Comply with global regulations",
  description: "Our Data Processing Agreement meets the requirements of the GDPR, and we offer Standard Contractual Clauses for compliant data transfer. Additionally, our Privacy Policy is compliant with global privacy laws such as the GDPR and CCPA. Segment is also HIPAA-eligible and able to sign BAAs to receive, maintain, and transmit PHI on behalf of our customers in the healthcare industry."
};
var Compliance_link = {
  text: "Learn about Segment Compliance",
  url: "/security/#commitment-to-data-privacy"
};

var Compliance_Customer = function Customer() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Compliance_Wrapper, {
    id: "compliance",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Compliance_StyledSectionBase, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Compliance_SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: Compliance_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h3",
            children: Compliance_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: Compliance_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Compliance_LinkWrapper, {
            size: "medium",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(Compliance_link.url, pageConfig),
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: Compliance_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Compliance_ComplianceImage, {})
      })]
    })
  });
};

var Compliance_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ef8j2sn3"
} : 0)("display:grid;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:45px;}" + ( true ? "" : 0));

var Compliance_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ef8j2sn2"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:0;grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var Compliance_LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "ef8j2sn1"
} : 0)( true ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : 0);

var Compliance_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ef8j2sn0"
} : 0)("display:flex;align-items:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:392px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var Compliance_Compliance = (Compliance_Customer);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Reliability/assets/Reliability@2x.png
var Reliability_2x = __webpack_require__(36954);
var Reliability_2x_default = /*#__PURE__*/__webpack_require__.n(Reliability_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Reliability/assets/Reliability.webp
var Reliability = __webpack_require__(19156);
var Reliability_default = /*#__PURE__*/__webpack_require__.n(Reliability);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/Reliability/assets/Reliability@2x.webp
var assets_Reliability_2x = __webpack_require__(92573);
var assets_Reliability_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Reliability_2x);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Reliability/ReliabilityImage.tsx







var ReliabilityImage = function ReliabilityImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Reliability_default()), ", ").concat((assets_Reliability_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (Reliability_2x_default()),
      alt: "Reliability",
      width: "666",
      height: "623",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Reliability_ReliabilityImage = (ReliabilityImage);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/Reliability/Reliability.tsx


function Reliability_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var Reliability_Description = function Description() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: ["We\u2019ve built our services to be highly available and reliable, so that our customers have access to the features they need, at any time. Our platform is designed to deliver", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      href: (0,getAbsoluteUrl/* default */.Z)("/infrastructure/#api", pageConfig),
      children: "99.9999%"
    }), " ", "uptime while providing transparent updates on any issues we're investigating."]
  });
};

var Reliability_copy = {
  overline: "Reliability",
  heading: "Robust platform reliability measures",
  description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reliability_Description, {})
};
var Reliability_link = {
  text: "Learn about Segment Reliability",
  url: "/infrastructure/"
};

var Reliability_Reliability = function Reliability() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reliability_Wrapper, {
    id: "infrastructure",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Reliability_StyledSectionBase, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reliability_SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: Reliability_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h3",
            children: Reliability_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: Reliability_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reliability_LinkWrapper, {
            size: "medium",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(Reliability_link.url, pageConfig),
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: Reliability_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reliability_ReliabilityImage, {})
      })]
    })
  });
};

var Reliability_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e101uw863"
} : 0)("display:grid;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:45px;}" + ( true ? "" : 0));

var Reliability_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e101uw862"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:0;grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var Reliability_LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e101uw861"
} : 0)( true ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : 0);

var Reliability_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e101uw860"
} : 0)("display:flex;align-items:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;}" + ( true ? "" : 0));

/* harmony default export */ var components_Reliability_Reliability = (Reliability_Reliability);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/RegionalSegment/assets/RegionalSegment@2x.png
var RegionalSegment_2x = __webpack_require__(68685);
var RegionalSegment_2x_default = /*#__PURE__*/__webpack_require__.n(RegionalSegment_2x);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/RegionalSegment/assets/RegionalSegment.webp
var RegionalSegment = __webpack_require__(88219);
var RegionalSegment_default = /*#__PURE__*/__webpack_require__.n(RegionalSegment);
// EXTERNAL MODULE: ./src/views/TrustCenter/components/RegionalSegment/assets/RegionalSegment@2x.webp
var assets_RegionalSegment_2x = __webpack_require__(98790);
var assets_RegionalSegment_2x_default = /*#__PURE__*/__webpack_require__.n(assets_RegionalSegment_2x);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/RegionalSegment/RegionalSegmentImage.tsx







var RegionalSegmentImage = function RegionalSegmentImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((RegionalSegment_default()), ", ").concat((assets_RegionalSegment_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (RegionalSegment_2x_default()),
      alt: "Regional Segment",
      width: "750",
      height: "549",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var RegionalSegment_RegionalSegmentImage = (RegionalSegmentImage);
;// CONCATENATED MODULE: ./src/views/TrustCenter/components/RegionalSegment/RegionalSegment.tsx


function RegionalSegment_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var RegionalSegment_copy = {
  overline: "Regional Segment",
  heading: "Regional infrastructure",
  description: "Segment is committed to our customers globally, which is why we offer regional infrastructure in both Europe and the United States. Regional Segment allows you to access tools and controls that help you practice good data etiquette and comply with EU data regulations like the GDPR."
};
var RegionalSegment_link = {
  text: "Learn about Regional Segment",
  url: "/product/gdpr/"
};

var RegionalSegment_RegionalSegment = function RegionalSegment() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionalSegment_Wrapper, {
    id: "regional-segment",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RegionalSegment_StyledSectionBase, {
      variant: "2Col",
      copyVariant: "narrow",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionalSegment_SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: RegionalSegment_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h3",
            children: RegionalSegment_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: RegionalSegment_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionalSegment_LinkWrapper, {
            size: "medium",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(RegionalSegment_link.url, pageConfig),
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: RegionalSegment_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionalSegment_RegionalSegmentImage, {})
      })]
    })
  });
};

var RegionalSegment_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e15hwasd3"
} : 0)("display:grid;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:45px;}" + ( true ? "" : 0));

var RegionalSegment_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e15hwasd2"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:0;grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var RegionalSegment_LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e15hwasd1"
} : 0)( true ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : 0);

var RegionalSegment_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e15hwasd0"
} : 0)("display:flex;align-items:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var components_RegionalSegment_RegionalSegment = (RegionalSegment_RegionalSegment);
;// CONCATENATED MODULE: ./src/views/TrustCenter/TrustCenter.tsx




















var TrustCenterView = function TrustCenterView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Trust Center - Privacy, Security & Compliance | Twilio Segment",
      pageDescription: "Maximize customer engagement with first party data, powered by a platform you can trust. Learn how Twilio Segment diligently meets global security standards, and protects the privacy and infrastructure of our customer data platform.",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {
        after: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnavigation_Subnavigation, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerEngagement_CustomerEngagement, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Security, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Privacy, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Compliance_Compliance, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RegionalSegment_RegionalSegment, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Reliability_Reliability, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CuriousAbout_CuriousAbout, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BuildCustomerTrust_BuildCustomerTrust, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "efgvq3z0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TrustCenter = (TrustCenterView);
;// CONCATENATED MODULE: ./src/pages/trust-center.tsx



var Sustainability = function Sustainability() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustCenter, {});
};

/* harmony default export */ var trust_center = (Sustainability);

/***/ }),

/***/ 52876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DividerSection_DividerSection; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.views.tsx


var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ec103ko0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.tsx





var DividerSection = function DividerSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

/* harmony default export */ var DividerSection_DividerSection = (DividerSection);

/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 68714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "d": function() { return /* reexport safe */ _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__.d; }
/* harmony export */ });
/* harmony import */ var _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83390);


/***/ }),

/***/ 83390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ scrollToAnchor; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var scrollToAnchor = function scrollToAnchor(anchorId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var addAnchorToUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var anchor = document.getElementById(anchorId);

  if (anchor) {
    var y = anchor.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({
      top: y,
      behavior: "smooth"
    });

    if (addAnchorToUrl) {
      history.pushState({}, "", "#".concat(anchorId));
    }
  }
};
/**
 * Scroll into view, given an anchor (element.id)
 *
 * @param anchorId - element id to be queried and scrolled to.
 * @param offset - offset from the top of the element to scroll to.
 * @return a function that scrolls to the anchor.
 */

var useScrollToAnchor = function useScrollToAnchor(anchorId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    scrollToAnchor(anchorId, offset);
  }, [anchorId, offset]);
  return scroll;
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToAnchor);

/***/ }),

/***/ 51336:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trust-center",
      function () {
        return __webpack_require__(81977);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97637:
/***/ (function(module) {

module.exports = "/_next/static/images/Compliance@2x-0bfabd00d449cda414d107cc66158e2d.png";

/***/ }),

/***/ 32377:
/***/ (function(module) {

module.exports = "/_next/static/images/Privacy-md-f5a71df4e72cd552ffb1cb28fb3c5be5.png";

/***/ }),

/***/ 46418:
/***/ (function(module) {

module.exports = "/_next/static/images/Privacy-md@2x-55c795c125c7aab1c7b92eee95cbb858.png";

/***/ }),

/***/ 84786:
/***/ (function(module) {

module.exports = "/_next/static/images/Privacy-xs@2x-2fbaad76d5c6c6b6d02f66f037d5966e.png";

/***/ }),

/***/ 68685:
/***/ (function(module) {

module.exports = "/_next/static/images/RegionalSegment@2x-04a6298c6b6cced10a85cb6d706c0524.png";

/***/ }),

/***/ 36954:
/***/ (function(module) {

module.exports = "/_next/static/images/Reliability@2x-8a94a6499bba775868e75b890896d1b3.png";

/***/ }),

/***/ 7519:
/***/ (function(module) {

module.exports = "/_next/static/images/Security-md-010566afcd4f4b17cb5373c18f3ffa83.png";

/***/ }),

/***/ 75736:
/***/ (function(module) {

module.exports = "/_next/static/images/Security-md@2x-ba0a1b27535936a22ca984c6484b1d8b.png";

/***/ }),

/***/ 25471:
/***/ (function(module) {

module.exports = "/_next/static/images/Security-xs@2x-6ec76d08b12cbbfcfa2f697e294be854.png";

/***/ }),

/***/ 81540:
/***/ (function(module) {

module.exports = "/_next/static/images/Compliance-62f58544a36e75a83e507bfc1429689d.webp";

/***/ }),

/***/ 48664:
/***/ (function(module) {

module.exports = "/_next/static/images/Compliance@2x-0de0066c7240b0beb61cb95646cbbb22.webp";

/***/ }),

/***/ 93810:
/***/ (function(module) {

module.exports = "/_next/static/images/Privacy-md-483994f56e0afc0e26cfbdf0afab9d78.webp";

/***/ }),

/***/ 44655:
/***/ (function(module) {

module.exports = "/_next/static/images/Privacy-md@2x-e4e7b9cb11df2d4c3bcaceb6081aec98.webp";

/***/ }),

/***/ 50604:
/***/ (function(module) {

module.exports = "/_next/static/images/Privacy-xs-4a81fd3b0fbb1145ffcb1c8867192424.webp";

/***/ }),

/***/ 26474:
/***/ (function(module) {

module.exports = "/_next/static/images/Privacy-xs@2x-40d7be3e3cfac5bbfde3c625a191c764.webp";

/***/ }),

/***/ 88219:
/***/ (function(module) {

module.exports = "/_next/static/images/RegionalSegment-743adcbe57cd8216dff98b86b83fe461.webp";

/***/ }),

/***/ 98790:
/***/ (function(module) {

module.exports = "/_next/static/images/RegionalSegment@2x-0f456bf582b8308fa209bcc56e3cc277.webp";

/***/ }),

/***/ 19156:
/***/ (function(module) {

module.exports = "/_next/static/images/Reliability-863735fc7367260f98b8fbe5617cf886.webp";

/***/ }),

/***/ 92573:
/***/ (function(module) {

module.exports = "/_next/static/images/Reliability@2x-0b9b07e817ffd7dd9367144d94c22794.webp";

/***/ }),

/***/ 84561:
/***/ (function(module) {

module.exports = "/_next/static/images/Security-md-1fb5b7a91bbcd05f66f928e5e8e21cac.webp";

/***/ }),

/***/ 11037:
/***/ (function(module) {

module.exports = "/_next/static/images/Security-md@2x-01ee008d7f5ea03fb75f78fba4ebd071.webp";

/***/ }),

/***/ 59193:
/***/ (function(module) {

module.exports = "/_next/static/images/Security-xs-16735e3b01d704755f6cdd09db3236d5.webp";

/***/ }),

/***/ 63940:
/***/ (function(module) {

module.exports = "/_next/static/images/Security-xs@2x-fd763abf6ac0bde150af04533202f77a.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,1382,4136,8392,2073,7096,2429,7303,8187,2065,9833,9774,2888,179], function() { return __webpack_exec__(51336); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);